import React, { Component } from "react";
import Modal from "./Modal";
import getWeb3 from "./getWeb3";
import sleepy from "./xsleepy-export.gif";
import dfkRouter from "./dfkRouter.json";
import panRouter from "./panRouter.json";
import dfkFactory from "./dfkFactory.json";
import erc20 from "./ERC20.json";
import { ethers } from "ethers";
import BigNumber from "bignumber.js";
import wand from "./wand.mp3";
import "./App.css";
import {
  MDBCol,
  MDBRow,
  MDBInput,
  MDBContainer,
  MDBBtn,
  MDBInputGroup,
  MDBCard,
  MDBCardBody,
  MDBCardText,
  MDBCardFooter,
  MDBCardHeader,
  MDBCardTitle,
  MDBSpinner,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBCollapse,
} from "mdb-react-ui-kit";
import dfkImg from "./jewel.gif";
import spookyImg from "./spookyswap.gif";
import panImg from "./pangolin.gif";
import uniswapImg from "./uni.gif";
import quickImg from "./quickswap.gif";
import pancakeImg from "./pancakeswap.gif";
import { hrc20, frc20, arc20, prc20, bsc20, eth20 } from "./ammTokens.js";
import metamaskImg from "./MetaMask_Fox.svg";
import QrModal from "./QrModal";

class App extends Component {
  // the constructor is run at the beginning of the program and is used for importing props
  constructor(props) {
    // the super function must be called in order to use a constructor
    super(props);
    // set the initial state
    this.state = {
      donationAddress: "0x53E3371c0b061230602c744952aa783AB2C2901a",
      soundIcon: "🔊",
      makeToast: false,
      approveDisable: "d-none",
      swapDisable: "d-none",
      receiptModal: "",
      optSmModal: false,
      inputType: null,
      updatedErc20Json: [],
      information: "d-none",
      networkStyle: "d-none",
      btnStyle: "d-none",
      help: "Enter base and target address...",
      baseInstance: null,
      trackBtn: "mx-2",
      approveBtn: "d-none",
      stopBtn: "d-none",
      swapBtn: "d-none",
      gasPrice: null,
      web3: null,
      accounts: null,
      contract: null,
      networkId: null,
      baseContract: null,
      targetContract: null,
      targetPrice: 0,
      currentPrice: null,
      baseName: null,
      baseAmount: 1,
      targetName: null,
      wethName: null,
      message: null,
      fontColor: "white",
      minutes: "0 seconds",

      allAmm: [
        {
          id: 1666600000,
          name: "DeFi Kingdoms",

          btn: "success",
          tokens: hrc20,
          gif: dfkImg,
          routerAddress: "0x24ad62502d1C652Cc7684081169D04896aC20f30",
          routerJson: dfkRouter,
          factoryJson: dfkFactory,
          networkParams: {
            chainId: "0x63564c40",
            chainName: "Harmony ONE Shard 0",
            nativeCurrency: {
              name: "ONE",
              symbol: "ONE",
              decimals: 18,
            },
            rpcUrls: ["https://rpc.s0.t.hmny.io"],
            blockExplorerUrls: ["https://explorer.harmony.one/"],
          },
          networkName: "Harmony ONE",
          explorer: `https://explorer.harmony.one/`,
          link: "https://beta.defikingdoms.com/#/marketplace",
          networkImg:
            "https://firebasestorage.googleapis.com/v0/b/defi-kingdoms.appspot.com/o/tokens%2FWONE.png?alt=media",
          img: "https://firebasestorage.googleapis.com/v0/b/defi-kingdoms.appspot.com/o/tokens%2FJEWEL.png?alt=media",
          btc: "0x72Cb10C6bfA5624dD07Ef608027E366bd690048F",
          usdc: "0x985458E523dB3d53125813eD68c274899e9DfAb4",
          usdt: "0x3c2b8be99c50593081eaa2a724f0b8285f5aba8f",
        },
        {
          id: 250,
          name: "SpookySwap",

          btn: "info",
          tokens: frc20,
          gif: spookyImg,
          routerAddress: "0xF491e7B69E4244ad4002BC14e878a34207E38c29",
          routerJson: dfkRouter,
          factoryJson: dfkFactory,
          networkParams: {
            chainId: "0xfa",
            chainName: "Fantom Opera",
            nativeCurrency: {
              name: "Fantom",
              symbol: "FTM",
              decimals: 18,
            },
            rpcUrls: ["https://rpc.ftm.tools/"],
            blockExplorerUrls: ["https://ftmscan.com/"],
          },
          networkName: "Fantom",
          explorer: "https://ftmscan.com/",
          link: `https://spookyswap.finance/`,
          networkImg:
            "https://assets.coingecko.com/coins/images/4001/small/Fantom.png?1558015016",
          img: "https://assets.coingecko.com/coins/images/15223/small/logo_200x200.png?1621992076",
          btc: "0x841fad6eae12c286d1fd18d1d525dffa75c7effe",
          usdc: "0x04068da6c83afcfa0e13ba15a6696662335d5b75",
          usdt: "0x049d68029688eabf473097a2fc38ef61633a3c7a",
        },
        {
          id: 43114,
          name: "Pangolin",

          btn: "danger",
          tokens: arc20,
          gif: panImg,
          routerAddress: "0xE54Ca86531e17Ef3616d22Ca28b0D458b6C89106",
          routerJson: panRouter,
          factoryJson: dfkFactory,
          networkParams: {
            chainId: "0xa86a",
            chainName: "Avalanche Network",
            nativeCurrency: {
              name: "Avalanche",
              symbol: "AVAX",
              decimals: 18,
            },
            rpcUrls: ["https://api.avax.network/ext/bc/C/rpc"],
            blockExplorerUrls: ["https://snowtrace.io/"],
          },
          networkName: "Avalanche",
          explorer: "https://snowtrace.io/",
          link: `https://app.pangolin.exchange/#/swap`,
          networkImg:
            "https://assets.coingecko.com/coins/images/12559/small/coin-round-red.png?1604021818",
          img: "https://app.pangolin.exchange/static/media/logo_dark.1943e1c4.svg",
          btc: "0x50b7545627a5162f82a992c33b87adc75187b218",
          usdc: "0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e",
          usdt: "0xc7198437980c041c805a1edcba50c1ce5db95118",
        },
        {
          id: 137,
          name: "QuickSwap",
          btn: "secondary",
          tokens: prc20,
          gif: quickImg,
          routerAddress: "0xa5E0829CaCEd8fFDD4De3c43696c57F7D7A678ff",
          routerJson: dfkRouter,
          factoryJson: dfkFactory,
          networkParams: {
            chainId: "0x89",
            chainName: "Polygon",
            nativeCurrency: {
              name: "Polygon",
              symbol: "MATIC",
              decimals: 18,
            },
            rpcUrls: ["https://polygon-rpc.com/"],
            blockExplorerUrls: ["https://polygonscan.com/"],
          },
          networkName: "Polygon",
          explorer: "https://polygonscan.com/",
          link: `https://quickswap.exchange/#/swap`,
          networkImg:
            "https://assets.coingecko.com/coins/images/4713/small/matic-token-icon.png?1624446912",
          img: "https://assets.coingecko.com/coins/images/13970/small/1_pOU6pBMEmiL-ZJVb0CYRjQ.png?1613386659",
          btc: "0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6",
          usdc: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
          usdt: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
        },
        {
          id: 56,
          name: "PancakeSwap",
          btn: "warning",
          tokens: bsc20,
          gif: pancakeImg,
          routerAddress: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
          routerJson: dfkRouter,
          factoryJson: dfkFactory,
          networkParams: {
            chainId: "0x38",
            chainName: "Binance Smart Chain",
            nativeCurrency: {
              name: "Binance Coin",
              symbol: "BNB",
              decimals: 18,
            },
            rpcUrls: ["https://bsc-dataseed.binance.org/"],
            blockExplorerUrls: ["https://bscscan.com"],
          },
          networkName: "Binance",
          explorer: "https://bscscan.com/",
          link: `https://pancakeswap.finance/`,
          networkImg:
            "https://assets.coingecko.com/coins/images/825/small/bnb-icon2_2x.png?1644979850",
          img: "https://assets.coingecko.com/markets/images/687/small/pancakeswap.jpeg?1626060212",
          btc: "0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c",
          usdc: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
          usdt: "0x55d398326f99059ff775485246999027b3197955",
        },
        {
          id: 1,
          name: "UniSwap V2",
          btn: "primary",
          tokens: eth20,
          gif: uniswapImg,
          routerAddress: "0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D",
          routerJson: dfkRouter,
          factoryJson: dfkFactory,
          networkParams: { chainId: "0x1" },
          networkName: "Ethereum",
          explorer: "https://etherscan.io/",
          link: `https://app.uniswap.org/#/swap?chain=mainnet`,
          networkImg:
            "https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880",
          img: "https://assets.coingecko.com/markets/images/535/small/256x256_Black-1.png?1590893262",
          btc: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
          usdc: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          usdt: "0xdac17f958d2ee523a2206206994597c13d831ec7",
        },
      ],
      ammData: {
        id: null,
        name: null,
        btn: null,
        tokens: null,
        gif: null,
        routerAddress: null,
        networkParams: null,
        networkName: null,
        explorer: null,
        link: null,
        routerJson: null,
        factoryJson: null,
        networkImg: null,
        img: null,

        networkImg: null,
        btc: null,
        usdc: null,
        usdt: null,
      },
      pathList: null,
      path: null,
      receipt: { transactionHash: null },
      baseBalanceOf: 0,
      targetBalanceOf: 0,
      baseDecimal: null,
      targetDecimal: null,
      dataStyle: "d-none",
      imgStyle: "",
      resetLoop: false,
      erc20Json: [
        {
          checksum: null,
          contract: null,
          symbol: null,
          name: null,
          balanceOf: null,
          img: dfkImg,
        },
      ],
      erc20List: null,
      menu: "d-none",
      baseName: null,
      baseImg: null,
      targetName: null,
      targetImg: null,
      targetStyle: "light",
      baseStyle: "light",
      targetSymbol: null,
      baseSymbol: null,
      info: "Loading...",
      mmStyle: "d-none",
    };

    // reload page if network is changed
    if (window.ethereum) {
      window.ethereum.on("chainChanged", (_chainId) =>
        window.location.reload()
      );
    }
  }
  // runs on mount
  componentDidMount = async () => {
    try {
      let routerAddress;
      let routerContract;
      // Get network provider and web3 instance.
      const web3 = await getWeb3();

      // Use web3 to get the user's accounts.
      const accounts = await web3.eth.getAccounts();

      // Get the contract instance.
      const networkId = await web3.eth.net.getId();
      console.log(web3.utils.toHex(networkId));
      console.log(networkId);

      let tokenList;
      let ethChecksum;
      // iterate throught allAmm and check if current network matches

      for (let x = 0; x < this.state.allAmm.length; x++) {
        if (this.state.allAmm[x].id === networkId) {
          routerAddress = this.state.allAmm[x].routerAddress;
          routerContract = new web3.eth.Contract(
            this.state.allAmm[x].routerJson.abi,
            routerAddress
          );
          const btcChecksum = await web3.utils.toChecksumAddress(
            this.state.allAmm[x].btc
          );
          const usdcChecksum = await web3.utils.toChecksumAddress(
            this.state.allAmm[x].usdc
          );
          const usdtChecksum = await web3.utils.toChecksumAddress(
            this.state.allAmm[x].usdt
          );
          if (this.state.allAmm[x].id === 43114) {
            ethChecksum = await routerContract.methods.WAVAX().call();
          } else {
            ethChecksum = await routerContract.methods.WETH().call();
          }
          const weth = await new web3.eth.Contract(erc20.abi, ethChecksum);
          const wethName = await weth.methods.name().call();
          tokenList = this.state.allAmm[x].tokens;

          this.setState({
            ammData: this.state.allAmm[x],
            pathList: [ethChecksum, btcChecksum, usdcChecksum, usdtChecksum],
            wethName,
          });
        }
      }
      if (!this.state.ammData.id) {
        this.setState({ btnStyle: "", info: "Select Network" });
        console.log("in");
      } else {
        this.setState({
          web3,
          accounts,
          contract: routerContract,
          networkId,
        });
        await this.makeJson(tokenList, accounts[0], web3);
      }

      // Set web3, accounts, and contract to the state, and then proceed with an
      // example of interacting with the contract's methods.
    } catch (error) {
      // Catch any errors for any of the above operations.
      alert(
        `Failed to load web3, accounts, or contract. Check console for details.`
      );
      this.setState({ mmStyle: "", info: "Get MetaMask" });
      console.error(error);
    }
  };

  switchNetwork = (ammData) => {
    if (this.state.networkId !== ammData.id) {
      if (ammData.id === 1) {
        window.ethereum
          .request({
            method: "wallet_switchEthereumChain",
            params: [ammData.networkParams],
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        window.ethereum
          .request({
            method: "wallet_addEthereumChain",
            params: [ammData.networkParams],
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      this.setState({ networkStyle: "d-none", imgStyle: "" });
    }
  };

  makeJson = async (erc20List, address, web3) => {
    let erc20Json = [];
    for (var x = 0; x < erc20List.length; x++) {
      try {
        const checksum = await web3.utils.toChecksumAddress(erc20List[x][0]);
        // used for testing new token addresses - get  symbol and name*
        // const weth = await new web3.eth.Contract(erc20.abi, checksum);
        // const wethsymbol = await weth.methods.name().call();
        // const wethName = await weth.methods.symbol().call();
        // console.log(wethName);
        // console.log(wethsymbol);
        erc20Json.push({
          checksum,
          img: erc20List[x][1],
          name: erc20List[x][2],
          symbol: erc20List[x][3],
        });
      } catch (error) {
        console.log(error);
        continue;
      }
    }
    console.log(erc20Json);
    const updatedErc20Json = erc20Json;
    this.setState({
      updatedErc20Json,
      erc20Json,
      baseContract: erc20Json[0].checksum,
      baseName: erc20Json[0].name,
      baseImg: erc20Json[0].img,
      targetContract: erc20Json[1].checksum,
      targetName: erc20Json[1].name,
      targetImg: erc20Json[1].img,
    });
  };

  refreshPage = () => {
    window.location.reload();
  };

  range = (start, end) => {
    const length = end - start;
    return Array.from({ length }, (_, i) => start + i);
  };

  formatAmountIn = async (base, amount) => {
    const baseName = await base.methods.name().call();
    const baseSymbol = await base.methods.symbol().call();
    const baseDecimal = await base.methods.decimals().call();
    const baseMultiply = Math.pow(10, baseDecimal);
    const baseAmount = new BigNumber((baseMultiply * amount).toString());
    this.setState({ baseName, baseInstance: base, baseDecimal, baseSymbol });
    const amountIn = ethers.utils.parseUnits(baseAmount.toFixed(), "wei");
    return amountIn;
  };

  getPath = async (factory, pathList, baseChecksum, targetChecksum) => {
    const checkList = pathList;
    const noPair = "0x0000000000000000000000000000000000000000";
    let pair;
    var altPair0;
    var altPair1;
    pair = await factory.methods.getPair(baseChecksum, targetChecksum).call();
    if (pair === noPair) {
      for (let x = 0; x < checkList.length; x++) {
        altPair0 = await factory.methods
          .getPair(baseChecksum, checkList[x])
          .call();
        altPair1 = await factory.methods
          .getPair(targetChecksum, checkList[x])
          .call();
        if (altPair0 !== noPair && altPair1 !== noPair) {
          return [baseChecksum, checkList[x], targetChecksum];
        }
        break;
      }
    } else {
      return [baseChecksum, targetChecksum];
    }
  };

  secToHrMinSec = (seconds) => {
    if (seconds === 0) {
      return "1 seconds";
    }
    const d = Number(seconds);
    const h = Math.floor(d / 3600);
    const m = Math.floor((d % 3600) / 60);
    const s = Math.floor((d % 3600) % 60);
    const hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
    const mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
    const sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
    return hDisplay + mDisplay + sDisplay;
  };

  resetLoop = async () => {
    this.setState({
      dataStyle: "d-none",
      resetLoop: true,
      imgStyle: "",
      optSmModal: false,
      menu: "d-none",
    });
    if (this.state.dataStyle === "d-none" && this.state.resetLoop === true) {
      this.setState({
        trackBtn: "mx-2",
        approveBtn: "d-none",
        swapBtn: "d-none",
        stopBtn: "d-none",
        minutes: "0 seconds",
        help: "Enter base and target address...",
        baseAmount: 0,
        networkStyle: "d-none",
        menu: "d-none",
      });
    }
  };

  startLoop = () => {
    this.setState({
      imgStyle: "",
      resetLoop: false,
      menu: "d-none",
      information: "d-none",
      dataStyle: "d-none",
      networkStyle: "d-none",
    });

    if (this.state.imgStyle === "" || !this.state.resetLoop) {
      this.setState({
        resetLoop: false,
        minutes: "0 seconds",
        menu: "d-none",
        imgStyle: "",
        baseStyle: "light",
        targetStyle: "light",
        baseAmount: 0,
        dataStyle: "d-none",
        networkStyle: "d-none",
      });
      this.trackPrice();
    }
  };

  timer = (ms) => new Promise((res) => setTimeout(res, ms));

  trackPrice = async () => {
    try {
      let seconds = 0;
      const baseBool = this.state.web3.utils.isAddress(this.state.baseContract);
      const targetBool = this.state.web3.utils.isAddress(
        this.state.targetContract
      );
      if (
        this.state.baseName !== this.state.targetName &&
        this.state.ammData.id &&
        this.state.contract &&
        baseBool &&
        targetBool &&
        !this.state.resetLoop
      ) {
        console.log(this.state.erc20Json);
        this.setState({
          trackBtn: "d-none",
          approveBtn: "mx-2",
          stopBtn: "",
          help: "Enter target value...",
          minutes: "0 seconds",
          imgStyle: "",
          dataStyle: "d-none",
        });
        const baseChecksum = this.state.web3.utils.toChecksumAddress(
          this.state.baseContract
        );
        const targetChecksum = this.state.web3.utils.toChecksumAddress(
          this.state.targetContract
        );
        const factoryAddress = await this.state.contract.methods
          .factory()
          .call();
        const factory = await new this.state.web3.eth.Contract(
          this.state.ammData.factoryJson,
          factoryAddress
        );
        const path = await this.getPath(
          factory,
          this.state.pathList,
          baseChecksum,
          targetChecksum
        );
        console.log(path);
        this.setState({ path });

        const base = await new this.state.web3.eth.Contract(
          erc20.abi,
          baseChecksum
        );

        const target = await new this.state.web3.eth.Contract(
          erc20.abi,
          targetChecksum
        );

        const targetName = await target.methods.name().call();
        const targetSymbol = await target.methods.symbol().call();
        const targetDecimal = await target.methods.decimals().call();
        const targetMultiply = Math.pow(10, targetDecimal);
        const baseDecimal = await base.methods.decimals().call();
        const baseMultiply = Math.pow(10, baseDecimal);
        let hexAmountIn = await this.formatAmountIn(base, 1);
        this.setState({ targetDecimal });
        console.log(baseDecimal);
        console.log(typeof targetDecimal);

        let baseBalanceOf;
        let targetBalanceOf;
        if (this.state.baseContract === this.state.erc20Json[0].checksum) {
          await this.state.web3.eth.getBalance(
            this.state.accounts[0],
            function (err, result) {
              if (err) {
                console.log(err);
              } else {
                baseBalanceOf = result;
                console.log(result);
              }
            }
          );
        } else {
          baseBalanceOf = await base.methods
            .balanceOf(this.state.accounts[0])
            .call();
        }
        this.setState({
          baseBalanceOf: baseBalanceOf / baseMultiply,
          targetSymbol,
        });
        if (this.state.targetContract === this.state.erc20Json[0].checksum) {
          await this.state.web3.eth.getBalance(
            this.state.accounts[0],
            function (err, result) {
              if (err) {
                console.log(err);
              } else {
                targetBalanceOf = result;
              }
            }
          );
        } else {
          targetBalanceOf = await target.methods
            .balanceOf(this.state.accounts[0])
            .call();
        }
        this.setState({
          targetBalanceOf: targetBalanceOf / targetMultiply,
        });
        let targetPrice;
        let baseAmount;
        while (!this.state.resetLoop) {
          try {
            baseAmount = this.state.baseAmount;
            if (baseAmount > this.state.baseBalanceOf) {
              this.setState({ baseAmount: this.state.baseBalanceOf });
              baseAmount = this.state.baseBalanceOf;
            } else {
              this.setState({ baseAmount });
              baseAmount = this.state.baseAmount;
            }
            if (this.state.minutes === "0 seconds") {
              seconds = 0;
            }

            let price;
            if (baseAmount && baseAmount > 0) {
              hexAmountIn = await this.formatAmountIn(base, baseAmount);
            } else {
              hexAmountIn = await this.formatAmountIn(base, 1);
            }
            try {
              price = await this.state.contract.methods
                .getAmountsOut(hexAmountIn, path)
                .call();
            } catch (error) {
              console.log(error);
              this.resetLoop();
            }
            const currentPrice = Number(
              price[price.length - 1] / targetMultiply
            );
            console.log(currentPrice);

            if (targetDecimal === 0) {
              this.setState({ currentPrice, targetName });
            } else {
              this.setState({
                currentPrice: currentPrice,
                targetName,
              });
            }

            this.setState({ currentPrice, targetName });
            if (seconds === 0) {
              if (targetDecimal === "0") {
                targetPrice = Number(currentPrice);
              } else {
                targetPrice = Number(currentPrice).toFixed(6);
              }

              this.setState({
                targetPrice,
              });
            }
            const nextTarget = this.state.targetPrice * baseAmount;
            const percent =
              (Number(currentPrice * baseAmount) / Number(nextTarget)) * 100;
            console.log(percent);
            const difference =
              Number(currentPrice * baseAmount) - Number(nextTarget);
            if (targetDecimal === "0") {
              this.setState({
                message: `${percent.toFixed()}% | ${difference.toFixed()}`,
              });
            } else {
              this.setState({
                message: `${percent.toFixed()}% | ${difference.toFixed(6)}`,
              });
            }

            if (Number(currentPrice * baseAmount) >= Number(nextTarget)) {
              if (percent >= 100) {
                this.setState({ fontColor: "green" });
              } else {
                this.setState({ fontColor: "red" });
              }
            } else {
              this.setState({ fontColor: "red" });
            }
            this.setState({ dataStyle: "", imgStyle: "d-none" });
            if (this.state.baseName === this.state.wethName) {
              await this.state.web3.eth.getBalance(
                this.state.accounts[0],
                function (err, result) {
                  if (err) {
                    console.log(err);
                  } else {
                    baseBalanceOf = result;
                  }
                }
              );
            } else {
              baseBalanceOf = await base.methods
                .balanceOf(this.state.accounts[0])
                .call();
            }
            this.setState({
              baseBalanceOf: baseBalanceOf / baseMultiply,
            });
            if (this.state.targetName === this.state.wethName) {
              await this.state.web3.eth.getBalance(
                this.state.accounts[0],
                function (err, result) {
                  if (err) {
                    console.log(err);
                  } else {
                    targetBalanceOf = result;
                  }
                }
              );
            } else {
              targetBalanceOf = await target.methods
                .balanceOf(this.state.accounts[0])
                .call();
            }

            this.setState({
              targetBalanceOf: targetBalanceOf / targetMultiply,
            });

            if (this.range(1, 999999).includes(seconds / 60)) {
              if (percent >= 100 && this.state.soundIcon === "🔊") {
                const audio = new Audio(wand);
                audio.play();
              }
            }

            let time = this.secToHrMinSec(seconds);
            this.setState({ minutes: time });

            await this.timer(3000);
            seconds += 3;
          } catch (error) {
            console.log(error);
            continue;
          }
        }
      } else {
        console.log("Invalid Input");
      }
    } catch (error) {
      console.log(error);
      this.resetLoop();
    }
  };

  approval = async () => {
    if (
      this.state.contract !== null &&
      this.state.baseBalanceOf >= this.state.baseAmount &&
      this.state.baseBalanceOf > 0 &&
      this.state.baseAmount > 0
    ) {
      this.setState({ approveDisable: "mx-2", approveBtn: "d-none" });
      let receiptModal = "Transaction Reverted!";
      let receipt;
      console.log("approve");
      const address = this.state.ammData.routerAddress;
      const hexAmountIn = await this.formatAmountIn(
        this.state.baseInstance,
        this.state.baseAmount
      );
      console.log(hexAmountIn);
      const weth = this.state.baseInstance;
      console.log("Awaiting Approval");
      try {
        await weth.methods
          .approve(address, hexAmountIn)
          .send({ from: this.state.accounts[0], gasPrice: this.state.gasPrice })
          .on("error", function (error) {
            console.log(error);
            console.log("Error");
            receiptModal = "An Error Occurred!";
          })
          .then(function (r) {
            console.log(r);
            console.log("Ready to Swap");
            receipt = r;
            receiptModal = "Approval Complete! ";
          });
        this.setState({
          approveDisable: "d-none",
          approveBtn: "d-none",
          swapBtn: "mx-2",
          receiptModal: `${receiptModal}`,

          receipt,
        });
        this.progressToggle();
      } catch (error) {
        console.log(error);

        this.setState({
          approveDisable: "d-none",
          approveBtn: "mx-2",
          swapBtn: "d-none",
          receiptModal: receiptModal,

          receipt: { transactionHash: null },
        });
        this.progressToggle();
      }
    } else {
      console.log(this.state.baseAmount);
      console.log(this.state.baseBalanceOf);
      console.log(this.state.contract);
    }
  };

  swapTokens = async () => {
    if (this.state.baseAmount > 0 && this.state.baseBalanceOf > 0) {
      this.setState({
        optSmModal: false,
        swapDisable: "mx-2",
        swapBtn: "d-none",
      });
      this.setState({});
      let receiptModal = "Transaction Reverted!";
      let receipt;
      const wethSymbol = this.state.wethName;
      const baseSymbol = this.state.baseName;
      const targetSymbol = this.state.targetName;
      const gasPrice = this.state.gasPrice;
      const contract = this.state.contract;
      const accounts = this.state.accounts;
      const path = this.state.path;
      console.log(path);
      const amountIn = await this.formatAmountIn(
        this.state.baseInstance,
        this.state.baseAmount
      );
      console.log(amountIn);

      const amountOut = new BigNumber(
        (
          this.state.currentPrice * Math.pow(10, this.state.targetDecimal)
        ).toFixed()
      );

      const amountOutMin0 = amountOut.minus(amountOut.dividedToIntegerBy("50"));
      console.log(amountOutMin0);
      const amountOutMin = ethers.utils.parseUnits(
        amountOutMin0.toFixed(),
        "wei"
      );
      const deadline = Date.now() + 1000 * 60 * 10; //10 minutes
      console.log(amountIn);
      console.log(amountOutMin);
      console.log(path);
      console.log(accounts[0]);
      console.log(deadline);
      try {
        if (baseSymbol !== wethSymbol && targetSymbol !== wethSymbol) {
          const gas = await contract.methods
            .swapExactTokensForTokensSupportingFeeOnTransferTokens(
              amountIn,
              amountOutMin,
              path,
              accounts[0],
              deadline
            )
            .estimateGas({ from: accounts[0] });

          await contract.methods
            .swapExactTokensForTokensSupportingFeeOnTransferTokens(
              amountIn,
              amountOutMin,
              path,
              accounts[0],
              deadline
            )
            .send({ from: accounts[0], gasPrice, gas })
            .once("receipt", function (r) {
              console.log(r);
            })
            .then(function (r) {
              receipt = r;
              receiptModal = "Swap Complete!";
            });
        } else if (baseSymbol === wethSymbol && targetSymbol !== wethSymbol) {
          if (this.state.ammData.name === "Pangolin") {
            const gas = await contract.methods
              .swapExactAVAXForTokensSupportingFeeOnTransferTokens(
                amountOutMin,
                path,
                accounts[0],
                deadline
              )
              .estimateGas({ from: accounts[0], value: amountIn });

            await contract.methods
              .swapExactAVAXForTokensSupportingFeeOnTransferTokens(
                amountOutMin,
                path,
                accounts[0],
                deadline
              )
              .send({ from: accounts[0], gasPrice, gas, value: amountIn })
              .once("receipt", function (r) {
                console.log(r);
              })
              .then(function (r) {
                receipt = r;
                receiptModal = "Swap Complete!";
              });
          } else {
            const gas = await contract.methods
              .swapExactETHForTokensSupportingFeeOnTransferTokens(
                amountOutMin,
                path,
                accounts[0],
                deadline
              )
              .estimateGas({ from: accounts[0], value: amountIn });

            await contract.methods
              .swapExactETHForTokensSupportingFeeOnTransferTokens(
                amountOutMin,
                path,
                accounts[0],
                deadline
              )
              .send({ from: accounts[0], gasPrice, gas, value: amountIn })
              .once("receipt", function (r) {
                console.log(r);
              })
              .then(function (r) {
                receipt = r;
                receiptModal = "Swap Complete!";
              });
          }
        } else {
          if (this.state.ammData.name === "Pangolin") {
            const gas = await contract.methods
              .swapExactTokensForAVAXSupportingFeeOnTransferTokens(
                amountIn,
                amountOutMin,
                path,
                accounts[0],
                deadline
              )
              .estimateGas({ from: accounts[0] });

            await contract.methods
              .swapExactTokensForAVAXSupportingFeeOnTransferTokens(
                amountIn,
                amountOutMin,
                path,
                accounts[0],
                deadline
              )
              .send({ from: accounts[0], gasPrice, gas })
              .once("receipt", function (r) {
                console.log(r);
              })
              .then(function (r) {
                receipt = r;
                receiptModal = "Swap Complete!";
              });
          } else {
            const gas = await contract.methods
              .swapExactTokensForETHSupportingFeeOnTransferTokens(
                amountIn,
                amountOutMin,
                path,
                accounts[0],
                deadline
              )
              .estimateGas({ from: accounts[0] });

            await contract.methods
              .swapExactTokensForETHSupportingFeeOnTransferTokens(
                amountIn,
                amountOutMin,
                path,
                accounts[0],
                deadline
              )
              .send({ from: accounts[0], gasPrice, gas })
              .once("receipt", function (r) {
                console.log(r);
              })
              .then(function (r) {
                receipt = r;
                receiptModal = "Swap Complete!";
              });
          }
        }
        this.setState({
          receipt,
          swapDisable: "d-none",
          swapBtn: "d-none",
          approveBtn: "mx-2",
          receiptModal: receiptModal,
        });
        this.progressToggle();
      } catch (error) {
        console.log(error);
        this.setState({
          swapDisable: "d-none",
          swapBtn: "mx-2",
          approveBtn: "d-none",
          receiptModal: "An Error Occurred!",
          receipt: { transactionHash: null },
        });
        this.progressToggle();
      }
    }
  };

  progressToggle = () => {
    this.setState({ makeToast: !this.state.makeToast });
  };

  baseToggle = () => {
    if (this.state.tokenType === "Base") {
      if (this.state.inputType === "button") {
        this.setState({
          baseStyle: "light",
          menu: "d-none",
          information: "d-none",
          imgStyle: "",
          tokenType: null,
          networkStyle: "d-none",
          updatedErc20Json: this.state.erc20Json,
        });
      } else {
        this.setState({
          menu: "row__posters2",
          information: "",
          imgStyle: "d-none",
          tokenType: "Base",
          baseStyle: this.state.ammData.btn,
          targetStyle: "light",
          networkStyle: "d-none",
        });
      }
    } else {
      this.setState({
        menu: "row__posters2",
        information: "",
        imgStyle: "d-none",
        tokenType: "Base",
        baseStyle: this.state.ammData.btn,
        targetStyle: "light",
        networkStyle: "d-none",
        updatedErc20Json: this.state.erc20Json,
      });
    }
    console.log(this.state.tokenType);
  };

  targetToggle = () => {
    if (this.state.tokenType === "Target") {
      if (this.state.inputType === "button") {
        this.setState({
          targetStyle: "light",
          menu: "d-none",
          information: "d-none",
          imgStyle: "",
          tokenType: null,
          networkStyle: "d-none",
          updatedErc20Json: this.state.erc20Json,
        });
      } else {
        this.setState({
          menu: "row__posters2",
          information: "",
          imgStyle: "d-none",
          tokenType: "Target",
          targetStyle: this.state.ammData.btn,
          baseStyle: "light",
          networkStyle: "d-none",
        });
      }
    } else {
      this.setState({
        menu: "row__posters2",
        information: "",
        imgStyle: "d-none",
        tokenType: "Target",
        targetStyle: this.state.ammData.btn,
        baseStyle: "light",
        networkStyle: "d-none",
        updatedErc20Json: this.state.erc20Json,
      });
    }
    console.log(this.state.tokenType);
  };

  selectToken = (data) => {
    if (this.state.tokenType === "Base") {
      this.setState({
        baseContract: data.checksum,
        baseName: data.name,
        baseImg: data.img,
        menu: "d-none",
        information: "d-none",
        imgStyle: "",
        tokenType: null,
        baseStyle: "light",
      });
    } else if (this.state.tokenType === "Target") {
      this.setState({
        targetContract: data.checksum,
        targetName: data.name,
        targetImg: data.img,
        menu: "d-none",
        information: "d-none",
        imgStyle: "",
        tokenType: null,
        targetStyle: "light",
      });
    }
  };

  selectNetwork = () => {
    this.setState({ networkStyle: "", imgStyle: "d-none" });
  };
  ////function for adding icons for tokens in MetaMask
  // getTokens = async () => {
  //   if (dexInfo !== null && dexInfo[0].id !== exchangeId) {
  //     setExchangeId(dexInfo[0].id);
  //     setUpdatedMarket([]);
  //     setCounter(0);
  //     setStyleType("d-none");
  //     setStyleType0("");
  //     setStyleType1("d-none");
  //     setStyleType2("d-none");
  //     setTokens([]);
  //     setBase([]);
  //     setTarget([]);
  //     const dexList = [dexInfo[0].id];
  //     let exchanges = [];
  //     let exchangeTokensString = [];
  //     let tempTickers = [];
  //     let tokenDetails = {};
  //     let exchangesMarkets = [];
  //     for (var a = 0; a < dexList.length; a++) {
  //       var exchangeData = await axios.get(
  //         `/exchanges/${dexList[a]}/tickers?include_exchange_logo=true`
  //       );
  //       exchanges.push(exchangeData.data);
  //     }
  //     setExchangeData(exchangeData.data);
  //     console.log(exchangeData.data);
  //     for (var d = 0; d < exchanges.length; d++) {
  //       exchangesMarkets.push(exchanges[d].tickers[0].market);
  //     }
  //     for (var b = 0; b < exchanges.length; b++) {
  //       exchangeData = exchanges[b].tickers;
  //       for (var j = 0; j < exchangeData.length; j++) {
  //         tempTickers.push(exchangeData[j].coin_id);
  //         tempTickers.push(exchangeData[j].target_coin_id);
  //       }
  //       var tickersSet = new Set(tempTickers);
  //       let tickerString = Array.from(tickersSet).join(",");
  //       exchangeTokensString.push(tickerString);
  //     }
  //     for (var i = 0; i < exchangeTokensString.length; i++) {
  //       var tokenData = await axios.get(
  //         `/coins/markets?vs_currency=usd&ids=${exchangeTokensString[i]}
  //   &order=volume_desc&per_page=50&page=1&sparkline=true&price_change_percentage=24h%2C7d%2C14d%2C30d%2C1y%20`
  //       );
  //       tokenDetails[exchangesMarkets[i].identifier] = tokenData.data;
  //     }
  //     console.log(exchangesMarkets);
  //     setAggregateTokens(tokenDetails);
  //     console.log(tokenDetails);
  //     setTokens(tokenDetails[dexList[0]]);
  //     console.log(tokenDetails[dexList[0]]);
  //   }
  // }
  //// switch ticker
  rotate = () => {
    this.setState({
      baseContract: this.state.targetContract,
      targetContract: this.state.baseContract,
      baseName: this.state.targetName,
      targetName: this.state.baseName,
      baseImg: this.state.targetImg,
      baseStyle: "light",
      targetStyle: "light",
      targetImg: this.state.baseImg,
      menu: "d-none",
      information: "d-none",
      imgStyle: "",
    });
    if (this.state.menu != "d-none") {
      this.setState({ menu: "d-none" });
    }
    this.resetLoop();
  };

  inputTokens = (type, value) => {
    let inputType = type;

    if (value) {
      let updatedErc20Json = [];
      let inputValue;

      const isAddress = this.state.web3.utils.isAddress(value);
      if (isAddress) {
        inputValue = this.state.web3.utils.toChecksumAddress(value);
        if (inputType === "base") {
          this.setState({ baseContract: inputValue });
        } else {
          this.setState({ targetContract: inputValue });
        }
      } else {
        inputValue = value;
      }
      for (let x = 0; x < this.state.erc20Json.length; x++) {
        if (
          this.state.erc20Json[x].symbol
            .toLowerCase()
            .includes(inputValue.toLowerCase()) ||
          this.state.erc20Json[x].name
            .toLowerCase()
            .includes(inputValue.toLowerCase()) ||
          this.state.erc20Json[x].checksum
            .toLowerCase()
            .includes(inputValue.toLowerCase())
        ) {
          updatedErc20Json.push(this.state.erc20Json[x]);
        }
      }
      if (updatedErc20Json.length === 0) {
        this.setState({
          updatedErc20Json,
          imgStyle: "",
          menu: "d-none",
          information: "d-none",
        });
      } else {
        this.setState({
          updatedErc20Json,
          imgStyle: "d-none",
          menu: "row__posters2",
          information: "",
        });
      }
    } else {
      this.setState({
        updatedErc20Json: this.state.erc20Json,
        imgStyle: "d-none",
        menu: "row__posters2",
        information: "",
      });
    }
  };

  toggleSound = () => {
    if (this.state.soundIcon === "🔊") {
      this.setState({ soundIcon: "🔈" });
    } else {
      this.setState({ soundIcon: "🔊" });
    }
  };

  render() {
    if (
      !this.state.web3 ||
      ![250, 1666600000, 43114, 137, 56, 1].includes(this.state.networkId)
    ) {
      return (
        <div className="App">
          <br />
          <div>
            <h3
              className="d-inline pointer white"
              title="Refresh Page"
              onClick={this.refreshPage}
            >
              <img src={sleepy}></img>{" "}
              <strong className={`pointer white link`}>{"SleepySwap"}</strong>
            </h3>
          </div>
          <div className="space"></div>

          <MDBContainer>
            <strong className="white">
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              {this.state.info}
            </strong>
            <MDBCol className={this.state.mmStyle}>
              <img
                onClick={(e) => {
                  e.preventDefault();
                  window.open("https://metamask.io/", "_blank");
                }}
                className="row__poster2 pointer"
                src={metamaskImg}
                alt="MetaMask"
                data-mdb-toggle="tooltip"
                data-mdb-placement="bottom"
                title="Link to MetaMask"
              />
            </MDBCol>

            <MDBCol className={this.state.btnStyle}>
              {this.state.allAmm.map((market) => (
                <img
                  onClick={() => this.switchNetwork(market)}
                  id={market.id}
                  key={market.id}
                  className="row__poster2 pointer"
                  src={market.networkImg}
                  alt={market.id}
                  href="#"
                  data-mdb-toggle="tooltip"
                  data-mdb-placement="bottom"
                  title={market.networkName}
                />
              ))}
            </MDBCol>
          </MDBContainer>
        </div>
      );
    }
    return (
      <div className="App">
        <Modal
          getProgress={this.state.makeToast}
          style={this.state.ammData.btn}
          receiptModal={this.state.receiptModal}
          explorer={this.state.ammData.explorer}
          hash={this.state.receipt.transactionHash}
          time={10}
        ></Modal>
        <br />
        <h3
          className="d-inline pointer white"
          title="Refresh Page"
          onClick={this.refreshPage}
        >
          <img src={sleepy}></img>{" "}
          <strong className={`pointer white link`}>{"SleepySwap"}</strong>
        </h3>
        <div>
          <div className="d-inline">
            <strong
              className={`pointer text-${this.state.ammData.btn} link d-inline`}
              title={`Link to ${this.state.ammData.networkName} Explorer`}
              onClick={(e) => {
                e.preventDefault();
                window.open(
                  `${this.state.ammData.explorer}address/${this.state.accounts[0]}`,
                  "_blank"
                );
              }}
            >
              <img
                src={this.state.ammData.networkImg}
                className="rotate pointer"
              ></img>
              {this.state.ammData.networkName}
            </strong>
          </div>
          <div className="d-inline">
            <strong
              className={`pointer text-${this.state.ammData.btn} link d-inline`}
              title={`Link to ${this.state.ammData.name}`}
              onClick={(e) => {
                e.preventDefault();
                window.open(this.state.ammData.link, "_blank");
              }}
            >
              <img
                src={this.state.ammData.img}
                className="rotate pointer"
              ></img>
              {this.state.ammData.name}
            </strong>
          </div>
        </div>
        <br />
        <MDBContainer>
          <MDBRow>
            <MDBCol className="center">
              <MDBCard
                border={this.state.ammData.btn}
                background="transparent"
                shadow="0"
                className="mb-3"
                style={{ width: "400px", maxHeight: "450px" }}
              >
                <MDBCardBody className={`text-${this.state.ammData.btn}`}>
                  <MDBRow>
                    <MDBCol className={this.state.imgStyle}>
                      <p className={`center text-${this.state.ammData.btn}`}>
                        Select Network
                      </p>
                    </MDBCol>
                    <MDBCol className={this.state.networkStyle}>
                      <p className={`center text-${this.state.ammData.btn}`}>
                        Select Network
                      </p>
                    </MDBCol>
                    <MDBCol className={this.state.information}>
                      <p className={`center text-${this.state.ammData.btn}`}>
                        {`Select ${this.state.tokenType}`}
                      </p>
                    </MDBCol>
                  </MDBRow>
                  <MDBRow>
                    <MDBCol className={this.state.imgStyle}>
                      <img
                        className="row__poster2 pointer"
                        title={`Choose Network`}
                        src={this.state.ammData.gif}
                        onClick={this.selectNetwork}
                        alt="Loading..."
                      ></img>
                    </MDBCol>
                    <MDBCol
                      size="12"
                      className={`center ${this.state.networkStyle}`}
                    >
                      {this.state.allAmm.map((market) => (
                        <img
                          onClick={() => this.switchNetwork(market)}
                          id={market.id}
                          key={market.id}
                          className="row__poster2 pointer"
                          src={market.networkImg}
                          alt={market.id}
                          href="#"
                          data-mdb-toggle="tooltip"
                          data-mdb-placement="bottom"
                          title={market.networkName}
                        />
                      ))}
                    </MDBCol>
                    <div className={this.state.menu}></div>
                    <MDBCol className={this.state.menu}></MDBCol>
                    <MDBCol size="12" className={this.state.menu}>
                      {this.state.updatedErc20Json.map((market) => (
                        <img
                          onClick={() => this.selectToken(market)}
                          id={market.name}
                          key={market.checksum}
                          className="row__poster2 pointer"
                          src={market.img}
                          alt={market.name}
                          href="#"
                          data-mdb-toggle="tooltip"
                          data-mdb-placement="bottom"
                          title={market.name}
                        />
                      ))}
                    </MDBCol>
                    <MDBCol className={`${this.state.menu}`}></MDBCol>

                    <MDBCol className={this.state.dataStyle}>
                      <div
                        className={`text-${this.state.ammData.btn} pointer`}
                        onClick={this.toggleSound}
                        title="Toggle Sound"
                      >
                        {`~ ${this.state.minutes} elapsed ${this.state.soundIcon} `}
                      </div>
                      <div
                        className={`${this.state.fontColor}`}
                        title="Distance from Target"
                      >
                        {`${this.state.targetPrice}: ${this.state.message}`}
                      </div>

                      <div
                        className={`text-${this.state.ammData.btn} `}
                        title="Target Amount"
                      >
                        {`🎯 ${this.state.currentPrice} ${this.state.targetSymbol} / `}{" "}
                      </div>
                      <div
                        title="Base Amount"
                        className={`text-${this.state.ammData.btn} `}
                      >
                        {`🏰 ${this.state.baseAmount} ${this.state.baseSymbol}`}
                      </div>
                    </MDBCol>
                  </MDBRow>
                  <br />
                  <MDBRow>
                    <MDBCol className={this.state.trackBtn}>
                      <MDBInputGroup className="center">
                        <MDBBtn
                          title="Choose Target"
                          className="group__btn center"
                          outline
                          color={this.state.targetStyle}
                          onClick={() => {
                            this.setState(
                              { inputType: "button" },
                              this.targetToggle
                            );
                          }}
                        >
                          <img
                            className="btn__icon"
                            title="Choose Target"
                            src={this.state.targetImg}
                            alt={this.state.targetName}
                          ></img>
                        </MDBBtn>
                        <MDBInput
                          className="group__input0"
                          label={`Target: ${this.state.targetName}`}
                          title="Enter target address, name or symbol"
                          placeholder={this.state.targetContract}
                          type="text"
                          id="formWhite"
                          contrast
                          onClick={() => {
                            this.setState(
                              { inputType: "input" },
                              this.targetToggle
                            );
                          }}
                          onChange={(e) => {
                            this.inputTokens("target", e.target.value);
                          }}
                        />
                      </MDBInputGroup>
                      <br />
                    </MDBCol>

                    <MDBCol className={`${this.state.stopBtn}`}>
                      <MDBInputGroup className="center">
                        <MDBInput
                          className="group__input1"
                          label={`Target: ${this.state.targetPrice} ${this.state.targetSymbol} for ${this.state.baseAmount} ${this.state.baseSymbol}`}
                          title={`${this.state.targetSymbol} Balance: ${this.state.targetBalanceOf}`}
                          type="text"
                          placeholder={this.state.targetPrice}
                          id="formWhite"
                          contrast
                          onChange={(e) => {
                            this.setState({ targetPrice: e.target.value });
                          }}
                        />
                      </MDBInputGroup>
                      <br />
                    </MDBCol>
                  </MDBRow>
                  <MDBRow>
                    <MDBCol className={this.state.trackBtn}>
                      <MDBInputGroup className="center">
                        <MDBBtn
                          className="group__btn center"
                          title="Choose Base"
                          outline
                          color={this.state.baseStyle}
                          onClick={() => {
                            this.setState(
                              { inputType: "button" },
                              this.baseToggle
                            );
                          }}
                        >
                          <img
                            className="btn__icon"
                            title="Choose Base"
                            src={this.state.baseImg}
                            alt={this.state.baseName}
                          ></img>{" "}
                        </MDBBtn>
                        <MDBInput
                          className="group__input0"
                          label={`Base: ${this.state.baseName}`}
                          title="Enter base address, name or symbol"
                          placeholder={this.state.baseContract}
                          type="text"
                          id="base"
                          contrast
                          onClick={() => {
                            this.setState(
                              { inputType: "input" },
                              this.baseToggle
                            );
                          }}
                          onChange={(e) => {
                            this.inputTokens("base", e.target.value);
                          }}
                        />
                      </MDBInputGroup>
                      <br />
                    </MDBCol>

                    <MDBCol className={`${this.state.stopBtn}`}>
                      <MDBInputGroup className="center ">
                        <MDBInput
                          className={`group__input1`}
                          label={`Base Amount: ${this.state.baseAmount} ${this.state.baseName}`}
                          title={`${this.state.baseSymbol} Balance: ${this.state.baseBalanceOf}`}
                          placeholder={this.state.baseAmount}
                          type="text"
                          id="formWhite"
                          contrast
                          onChange={(e) => {
                            this.setState({ baseAmount: e.target.value });
                          }}
                        />{" "}
                      </MDBInputGroup>
                      <br />
                    </MDBCol>
                  </MDBRow>
                  <MDBRow>
                    <MDBCol>
                      <MDBBtn
                        color={this.state.ammData.btn}
                        size="lg"
                        outline
                        floating
                        title="Rotate Ticker"
                        className={`text-${this.state.ammData.btn} ${this.state.trackBtn}`}
                        onClick={this.rotate}
                      >
                        ⇅
                      </MDBBtn>
                      <MDBBtn
                        color={this.state.ammData.btn}
                        size="lg"
                        outline
                        rounded
                        className={`text-${this.state.ammData.btn} ${this.state.stopBtn}`}
                        onClick={this.resetLoop}
                      >
                        back
                      </MDBBtn>
                    </MDBCol>
                    <MDBCol>
                      <MDBBtn
                        color={this.state.ammData.btn}
                        size="lg"
                        outline
                        rounded
                        className={`text-${this.state.ammData.btn} ${this.state.trackBtn}`}
                        onClick={this.startLoop}
                      >
                        track
                      </MDBBtn>

                      <MDBBtn
                        color={this.state.ammData.btn}
                        size="lg"
                        outline
                        rounded
                        className={`text-${this.state.ammData.btn} ${this.state.approveBtn}`}
                        onClick={this.approval}
                      >
                        approve
                      </MDBBtn>

                      <MDBBtn
                        disabled
                        color={this.state.ammData.btn}
                        size="sm"
                        outline
                        rounded
                        className={`text-${this.state.ammData.btn} ${this.state.approveDisable}`}
                        onClick={this.approval}
                      >
                        <MDBSpinner
                          size="lg"
                          role="status"
                          tag="span"
                          className="me-2"
                        />
                      </MDBBtn>
                      <MDBBtn
                        color={this.state.ammData.btn}
                        size="lg"
                        outline
                        rounded
                        className={`text-${this.state.ammData.btn} ${this.state.swapBtn}`}
                        onClick={this.swapTokens}
                      >
                        swap
                      </MDBBtn>
                      <MDBBtn
                        disabled
                        color={this.state.ammData.btn}
                        size="sm"
                        outline
                        rounded
                        className={`text-${this.state.ammData.btn} ${this.state.swapDisable}`}
                        onClick={this.swapTokens}
                      >
                        <MDBSpinner
                          size="lg"
                          role="status"
                          tag="span"
                          className="me-2"
                        />
                      </MDBBtn>
                    </MDBCol>
                  </MDBRow>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
        <br />
        <footer>
          <br />
          <QrModal
            donate={this.state.donationAddress}
            color={this.state.ammData.btn}
          ></QrModal>
        </footer>
      </div>
    );
  }
}

export default App;
